import { Injectable } from '@angular/core';
import { GlobalConfig } from '../../../../../_core/global.config';
import { ApiService } from '../../../../../_services/api.service';
import { BaseEntityService } from '../../../../../_services/base.service';
import { InvoiceStatusFilterState } from '../_models/invoice-status-model';
import { InvoicePacketModel } from '../_models/invoice-packet.model';
import { InvoiceAuditModel } from '../_models/invoice-audit.model';
import { AccountingFileHistoryModel } from '../_models/accounting-file-history.model';
import { Observable } from 'rxjs';
import { HttpResponse } from '@angular/common/http';
import { InvoiceDashboardViewModel } from '../_models/invoice-dashboard.viewmodel';
import { DateTime } from '../../../../../_core/date';
import { map } from 'rxjs/operators';
import { ApplicationLogFilterModel } from '../_models/application-log-filter.model';
import { BillingAuditGridData, BillingAuditTenantGridData } from '../_models/billing-audit.model';

@Injectable({
    providedIn: 'root'
})
export class InvoicePeriodService extends BaseEntityService<InvoicePacketModel> {
    constructor(readonly apiService: ApiService, private readonly config: GlobalConfig) {
        super(apiService);
    }

    protected get billingLogsUri():string{
        return `${this.config.api('platform').baseUri}/log/v2`;
  
    }

    protected get baseUri(): string {
        return `${this.config.api('platform').baseUri}/invoicing/metering/period`;
    }    

    protected get AccountingPeriodUri(): string {
        return `${this.config.api('platform').baseUri}/invoicing/metering/accountingperiod`;
    }    

    public getInvoices(buildingId: number) {
        return this.apiService.query<InvoicePacketModel>(this.baseUri + '/building/' + buildingId);
    }

    //  Create a batch of invoices for a building
    public batchInvoices(buildingId: number, model: InvoicePacketModel) {     
        return this.apiService.insert<InvoicePacketModel>(this.baseUri + '/building/' + buildingId, model);
    }

    //  Regenerate a packet of invoices for a building
    public regeneratePacket(model: InvoicePacketModel) {
        return this.apiService.insert<InvoicePacketModel>(this.baseUri + '/regenerate/' + model.Id, null);
    }

    //  Create a batch of invoices for a building
    public batchCancel(buildingId: number, model: InvoicePacketModel) {
        return this.apiService.update<InvoicePacketModel>(this.baseUri + '/building/' + buildingId + '/cancel', model);
    }

    public requestInvoiceChange(buildingId: number, model: InvoicePacketModel) {
        return this.apiService.patchSingle<InvoicePacketModel>(this.baseUri + '/building/' + buildingId +  '/requestInvoiceChange', model);
    }

    //  Create a batch of invoices for a building
    public auditInvoice(invoicePeriodId: number) {
        return this.apiService.query<InvoiceAuditModel>(this.baseUri + '/audit/' + invoicePeriodId);
    }

    //  Upload an accounting file for a particular accounting period
    public uploadAccountingFile(invoicePeriodId: number) {
        return this.apiService.post<InvoicePacketModel>(this.baseUri + '/upload/' + invoicePeriodId);
    }

    //  Create a batch of invoices for a building
    public ftpHistory(AccountingPeriodId: number) {
        return this.apiService.query<AccountingFileHistoryModel>(this.baseUri + '/ftphistory/' + AccountingPeriodId);
    }

    public fetchBillingLogs(queryObject:ApplicationLogFilterModel) {
        return this.apiService.query<AccountingFileHistoryModel>(this.billingLogsUri +'/search',queryObject);
    }

    // public search(request?: InvoiceStatusFilterState) {
    //     return super.search(request) as any;
    // }

    public getInvoicePeriodHistory(request?: InvoiceStatusFilterState) {
        return this.apiService.querySingle<InvoiceDashboardViewModel>(this.baseUri + '/getInvoicePeriodHistory', request);
    }

    public getInvoicePacketForBillingPeriod(model:{BuildingId:number , BillingPeriodId:number}){
        return this.apiService.query<{InvoicePacketId:number,InvoicePeriod:string}>(this.baseUri + '/getInvoicePeriod',model)
    }

    public buildingAuditInvoice(param) {
        return this.apiService.query<BillingAuditGridData | BillingAuditTenantGridData>(this.baseUri + '/audit/billing', param);
    }
}
